import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Container,
  Card,
  CardBody,
  FormFeedback,
  Label,
  InputGroup,
  FormGroup
} from "reactstrap";
import {
  clearEnableUserError,
  logoutUser,
  resetPassword,
  resetPasswordForm
} from "../../store/actions.js";
import { Link, useParams, Navigate, useNavigate } from "react-router-dom";
// import logolight from "../../assets/images/only-switch-logo.png";
// import logodark from "../../assets/images/only-switch-logo.png";
import logolight from "../../assets/images/sixbit-logo-bg.jpg";
import logodark from "../../assets/images/sixbit-logo-bg.jpg";
import Message from "../../CommonData/Data/Message.js";
import success from '../../assets/images/success-msg.png';

const ResetPassword = (props) => {

  const [codes, setCode] = useState("");
  const [showPasword1, setshowPasword1] = useState(true);
  const [showPasword2, setshowPasword2] = useState(true);
  const credits = window.__ENV && window.__ENV.credits;
  const params = useParams();
  const naviagate = useNavigate();
  const { code } = params;
  const { formReset, errorMessage, enableUserSuccess } = props;
  const { errors } = formReset || {};

  useEffect(() => {
    setCode(params.code);
    props.resetPasswordForm({ errors: {} })
    props.clearEnableUserError()
  }, []);

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    let result = {};
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      result = {
        isValid: emailRegex.test(value),
        message: 'Enter valid email',

      }
    }
    props.resetPasswordForm({
      ...formReset,
      [name]: value,
      errors: {
        [name]: result.isValid ? null : result.message,
      }
    })
  };

  //focus down while press enter 
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);
  const confirmPasswordInputRef = useRef(null);

  const handleKeyDown = (event, inputRef) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      inputRef.current.focus();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSubmit(e);
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const { confirmPassword, password, email, errors } = formReset;
    let currentErrors = {};
    if (!email) {
      currentErrors.email = 'Email is required';
    }
    if (!password) {
      currentErrors.password = 'Password is required';
    }
    if (!confirmPassword) {
      currentErrors.confirmPassword = 'Confirm password is required';
    }
    if (errors && errors.email) {
      currentErrors.email = 'Enter valid email'
    }
    props.resetPasswordForm({
      ...formReset,
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.resetPassword(codes);
    }
  };

  const handleLoginPage = () => {
    props.logoutUser();
    naviagate("/")
  }

  return (
    <div className="page-content">
      <React.Fragment>
        <div className="bg-overlay"></div>
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card className=''>
                  <CardBody className="p-4">
                    <div className="">
                      <div className="text-center">
                        <Link to="/" className="">
                          <img
                            src={logodark} alt="" height="80" className="auth-logo logo-dark mx-auto" />
                          <img src={logolight} alt="" height="80" className="auth-logo logo-light mx-auto" />
                        </Link>
                      </div>
                      {!enableUserSuccess ?
                        <>
                          <h4 className="font-size-18 text-muted mt-2 text-center">ENTER NEW PASSWORD</h4>
                          <form className="form-horizontal" action="#">
                            <Row className='mt-5'>
                              {errorMessage && (
                                <Message
                                  type="danger"
                                  defaultMessage={errorMessage}
                                  baseClassName="alert"
                                />
                              )}
                              <Col md={12}>
                                <FormGroup>
                                  <Label>Email</Label><span className="text-danger">*</span>
                                  <InputGroup>
                                    <Input
                                      autoFocus
                                      type="email"
                                      innerRef={emailInputRef}
                                      name="email"
                                      className={errors && errors.email ? "border-end-0" : 'border-end-0 border-secondary'}
                                      placeholder="Enter email address"
                                      onChange={validateOnChange}
                                      invalid={errors && errors.email}
                                      onKeyPress={(event) => handleKeyDown(event, passwordInputRef)}
                                    />
                                    <Button
                                      color='white'
                                      className={errors && errors.email ? "border-danger border-start-0 rounded-end" : 'border-dark border-start-0 rounded-end'}
                                      disabled
                                    ><i class="fas fa-envelope text-dark"></i>
                                    </Button>
                                    <FormFeedback>{errors && errors.email}</FormFeedback>
                                  </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                  <Label>Password</Label><span className="text-danger">*</span>
                                  <InputGroup>
                                    <Input
                                      type={showPasword1 ? "password" : "text"}
                                      innerRef={passwordInputRef}
                                      id="id-password"
                                      name="password"
                                      className={errors && errors.password ? "border-end-0" : 'border-end-0 border-secondary'}
                                      placeholder="Password"
                                      onChange={validateOnChange}
                                      invalid={errors && errors.password}
                                      onKeyPress={(event) => handleKeyDown(event, confirmPasswordInputRef)}
                                    />
                                    <Button
                                      className={errors && errors.password ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                                      color='white'
                                      onClick={() => setshowPasword1(!showPasword1)}
                                    >
                                      {showPasword1 ?
                                        <i className="fas fa-eye text-secondary"></i>
                                        :
                                        <i class="fas fa-eye-slash text-secondary"></i>
                                      }
                                    </Button>
                                    <FormFeedback>{errors && errors.password}</FormFeedback>
                                  </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                  <Label>Confirm Password</Label><span className="text-danger">*</span>
                                  <InputGroup>
                                    <Input
                                      type={showPasword2 ? "password" : "text"}
                                      innerRef={confirmPasswordInputRef}
                                      id="id-confirmpassword"
                                      name="confirmPassword"
                                      className={errors && errors.confirmPassword ? "border-end-0" : 'border-end-0 border-secondary'}
                                      placeholder="Confirm password"
                                      onChange={validateOnChange}
                                      onKeyPress={handleKeyPress}
                                      invalid={errors && errors.confirmPassword}
                                    />
                                    <Button
                                      className={errors && errors.password ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                                      color='white'
                                      onClick={() => setshowPasword2(!showPasword2)}
                                    >
                                      {showPasword2 ?
                                        <i className="fas fa-eye text-secondary"></i>
                                        :
                                        <i class="fas fa-eye-slash text-secondary"></i>
                                      }
                                    </Button>
                                    <FormFeedback>{errors && errors.confirmPassword}</FormFeedback>
                                  </InputGroup>
                                </FormGroup>
                                <div className="d-grid mt-4">
                                  <Button
                                    type='submit'
                                    color="primary"
                                    onClick={onSubmit}
                                    disabled={props.resetPasswordPending}
                                  >
                                    {props.resetPasswordPending ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Loading...
                                      </>
                                    ) : (
                                      "Confirm"
                                    )}
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </form></> :
                        <div className='text-center pt-2'>
                          <img
                            src={success}
                            alt=''
                            height='60'
                          />
                          <p className='text-success font-size-16 pt-2'>  {`${enableUserSuccess}'s account password was successfully updated...`}</p>
                          <Button
                            color="link"
                            className='text-decoration-underline text-info mt-4'
                            onClick={handleLoginPage}
                          >Go to login page
                          </Button>
                        </div>
                      }
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <div className="position-absolute bottom-0 start-50 translate-middle-x mt-5 text-center">
            <p className="text-white-50">
              © {new Date().getFullYear()} {credits}.
            </p>
          </div>

        </div>
      </React.Fragment >
    </div >
  );

}

const mapStateToProps = (state) => ({
  formReset: state.login.formReset,
  isAuth: state.login.isAuth,
  loginPage: state.login.loginPage,
  errorMessage: state.login.enableUserError,
  resetPasswordPending: state.login.resetPasswordPending,
  enableUserSuccess: state.login.enableUserSuccess,

});

const mapDispatchToProps = (dispatch) => ({
  resetPasswordForm: (formReset) => dispatch(resetPasswordForm(formReset)),
  resetPassword: (code) => dispatch(resetPassword(code)),
  clearEnableUserError: () => dispatch(clearEnableUserError()),
  logoutUser: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
